module.exports = __webpack_public_path__ + "static/media/logo_full.1c99d500.png";